export const checkBlob = (container, name, sas, callback) => {
	fetch(`https://utilicastclientpictures.blob.core.windows.net/${container}/${name}${sas}`, {method: 'HEAD'})
		.then(res => callback(res.ok))
		.catch(() => callback(false));
}
